// extracted by mini-css-extract-plugin
module.exports = {"three-d-shape-menu-popover":"AddObjectMenu_three-d-shape-menu-popover__UAh46","menu-item":"AddObjectMenu_menu-item__2MYgr","more-shapes":"AddObjectMenu_more-shapes__vb5Vx"};